var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import Button from '../../base/Button';
import Card, { CardBody, CardHeader, CardSubtitle, CardTitle } from '../../base/Card';
import Icon from '../../base/Icon';
import ListView from '../../base/ListView';
import Popup from '../../base/Popup';
var StyledButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        border-width: 0;\n        padding: 0.25rem;\n\n        &:hover {\n            color: ", "\n        }\n\n        &.k-focus::before,\n        &:focus::before,\n        &:hover::before {\n            opacity: 0;\n        }\n    "])), props.theme.component.secondaryHover));
var StyledCard = styled(Card)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        .k-card-header {\n            border-width: 0;\n            text-align: center;\n\n            .k-card-title {\n                color: ", ";\n            }\n\n            .k-card-subtitle {\n                color: ", ";\n                font-size: medium;\n                font-style: italic;\n            }\n        }\n\n        .k-card-body {\n            padding: 0 1rem;\n\n            .k-listview {\n                border-width: 0;\n\n                .k-listview-content {\n                    .list-item {\n                        padding: 0.5rem 0;\n\n                        &.border-top {\n                            border-top-color: ", ";\n                            border-top-style: solid;\n                            border-top-width: 1px;\n                        }\n\n                        & > svg {\n                            color: ", ";\n                        }\n                    }\n                }\n            }\n        }\n    "])), props.theme.colors.secondary, props.theme.colors.secondary, props.theme.component.spacer, props.theme.typography.link));
var labelRender = item => {
  if (item.link && Array.isArray(item.link) && item.link.length >= 2) {
    return /*#__PURE__*/React.createElement("span", null, item.prefix ? "".concat(item.prefix.trim(), " ") : '', /*#__PURE__*/React.createElement("a", {
      href: item.link.join(''),
      target: item.link[0] === 'tel:' ? '' : '_blank',
      rel: "noopener noreferrer"
    }, item.label ? item.label : item.link[1]));
  }
  return item.label;
};
var itemRender = list => {
  var {
    dataItem,
    index
  } = list;
  return /*#__PURE__*/React.createElement("div", {
    className: "list-item".concat(index > 0 ? ' border-top' : '')
  }, dataItem.icon && /*#__PURE__*/React.createElement(Icon, {
    icon: dataItem.icon
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: "".concat(dataItem.icon ? '8px' : '24px')
    }
  }, labelRender(dataItem)));
};
var SupportMenu = props => {
  var {
    email,
    emailSubject,
    link,
    phone,
    show
  } = props;
  var [data, setData] = useState([]);
  var [internalShow, setInternalShow] = useState(false);
  var anchor = useRef(null);
  var popup = useRef(null);
  var handleClick = e => {
    if (anchor.current.contains(e.target) || popup.current.contains(e.target)) {
      return;
    }
    setInternalShow(false);
  };
  useEffect(() => {
    var newData = [];
    if (phone) {
      newData.push({
        icon: ['fas', 'square-phone'],
        link: ['tel:', phone],
        prefix: 'Call us:'
      });
    }
    if (email) {
      newData.push({
        icon: ['fas', 'square-envelope'],
        link: ['mailto:', email, '?subject=', emailSubject || ''],
        prefix: 'Mail us:'
      });
    }
    if (link) {
      newData.push({
        icon: ['fas', 'book'],
        label: 'Visit the Support Center',
        link: ['', link]
      });
    }
    setData(newData);
  }, [email, emailSubject, link, phone]);
  useEffect(() => {
    if (internalShow) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [internalShow]);
  useEffect(() => setInternalShow(show), [show]);
  return /*#__PURE__*/React.createElement("div", {
    ref: anchor,
    style: {
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(StyledButton, {
    fillMode: "flat",
    onClick: () => setInternalShow(!internalShow),
    themeColor: "secondary"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: ['far', 'circle-question'],
    style: {
      height: '1.5rem',
      width: '1.5rem'
    }
  })), /*#__PURE__*/React.createElement(Popup, {
    anchor: anchor.current,
    anchorAlign: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    borderless: true,
    onClose: () => {
      setInternalShow(false);
    },
    popupAlign: {
      horizontal: 'right',
      vertical: 'top'
    },
    show: internalShow
  }, /*#__PURE__*/React.createElement("div", {
    ref: popup
  }, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement(CardHeader, null, /*#__PURE__*/React.createElement(CardTitle, null, /*#__PURE__*/React.createElement(Icon, {
    icon: ['far', 'circle-question'],
    size: "2x"
  })), /*#__PURE__*/React.createElement(CardSubtitle, null, "Need help?")), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(ListView, {
    data: data,
    item: itemRender
  }))))));
};
SupportMenu.defaultProps = {
  email: undefined,
  emailSubject: undefined,
  link: undefined,
  phone: undefined,
  show: undefined
};
SupportMenu.propTypes = {
  /**
   * The email address associated with the company's helpdesk.
   */
  email: PropTypes.string,
  /**
   * The subject of the email.
   */
  emailSubject: PropTypes.string,
  /**
   * The URL of the company's Support Center.
   */
  link: PropTypes.string,
  /**
   * The phone number associated with the company's helpdesk.
   */
  phone: PropTypes.string,
  /**
   *  Controls the Popup visibility.
   */
  show: PropTypes.bool
};
export default SupportMenu;